export const WIDGET_TOUR_NAMESPACE = 'jbp-widget-tour'

// i18n keys for the text the widget tour supplies itself, as opposed to the step text each
// tour config brings. Each is rendered with an English fallback until the store has copy.
export const WIDGET_TOUR_TRANSLATION_KEYS = {
  close: `${WIDGET_TOUR_NAMESPACE}-close`,
  previous: `${WIDGET_TOUR_NAMESPACE}-previous`,
  next: `${WIDGET_TOUR_NAMESPACE}-next`,
  finish: `${WIDGET_TOUR_NAMESPACE}-finish`,
  tourButton: `${WIDGET_TOUR_NAMESPACE}-tour-button`,
}
